var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sizes-legend"},[_c('svg',{ref:"legendContainer",staticClass:"root"})])}
var staticRenderFns = []

export { render, staticRenderFns }